import { Operation } from '@apollo/client';
import { getOperationName } from '@apollo/client/utilities';
import {
  RequestPasswordResetDocument,
  RequestAuthCodeDocument,
  ResetPasswordDocument,
  LogoutDocument,
  LoginDocument,
  SignUpDocument,
  VerifyAuthCodeDocument,
  IpDetailsDocument,
} from '@src/graphql/generated';

const PUBLIC_OPERATIONS = [
  SignUpDocument,
  LoginDocument,
  LogoutDocument,
  IpDetailsDocument,
  RequestPasswordResetDocument,
  ResetPasswordDocument,
  RequestAuthCodeDocument,
  VerifyAuthCodeDocument,
].map(operation => getOperationName(operation));

export function doesRequireAuth(request: Operation): boolean {
  if (!request.operationName) {
    return false;
  }

  return !PUBLIC_OPERATIONS.includes(request.operationName);
}
